export enum AuthOnFileRpaStatus {
  INITIATED = "initiated",
  COMPLETED = "completed",
  IN_PROGRESS = "in_progress",
  ERROR = "error",
}
